import { useDispatch, useSelector } from 'react-redux';
import { getType } from 'typesafe-actions';
import { googleClientid } from '../../../config/configConstants';
import { googleCalendarActions } from '../../../state/googleCalendar';
import { getGoogleCalendars } from '../../../state/calendar/selectors';
import { isConnectedWithGoogle } from '../../../state/googleCalendar/selectors';
import { loadGoogleIdentityServices } from './loadGoogleIdentityServices';

const SCOPES = ['https://www.googleapis.com/auth/calendar.events', 'https://www.googleapis.com/auth/calendar.readonly'].join(
  ' '
);

const CLIENT_ID = `${googleClientid}.apps.googleusercontent.com`;

async function requestAuthorizationCode(): Promise<string> {
  await loadGoogleIdentityServices();

  return new Promise((resolve, reject) => {
    const client = window.google!.accounts.oauth2.initCodeClient({
      client_id: CLIENT_ID,
      scope: SCOPES,
      ux_mode: 'popup',
      callback: response => {
        if (response.error) {
          reject(new Error(response.error_description || response.error));
          return;
        }
        if (!response.code) {
          reject(new Error('No authorization code received'));
          return;
        }
        resolve(response.code);
      }
    });
    client.requestCode();
  });
}

export function useGoogleApi() {
  const dispatch = useDispatch();
  const calendars = useSelector(getGoogleCalendars);
  const isConnected = useSelector(isConnectedWithGoogle);

  const approveAccessToGoogle = async (force: boolean = false, reconnect?: boolean) => {
    try {
      if (force || (!isConnected && !calendars.length)) {
        const code = await requestAuthorizationCode();
        dispatch({
          type: getType(googleCalendarActions.getGoogleAccess.request),
          payload: {
            code,
            reconnect
          }
        });
      } else if (!calendars.length) {
        dispatch({
          type: getType(googleCalendarActions.getSavedCalendars.request)
        });
      }
      return { ok: true };
    } catch (e) {
      console.log(e);
      return { ok: false };
    }
  };

  return { approveAccessToGoogle };
}

// GIS does not maintain a browser-side Google session like gapi.auth2 did.
export const googleAuth2SignOut = () => {};
